<div class="dialog-wrapper">
  <div class="dialog-header">
    <div class="dialog-title-group">
      <h2 mat-dialog-title>{{ 'manageUsers' | translate }}</h2>
      <span class="entity-badge">{{ data.entityType }} · {{ data.entityId }}</span>
    </div>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>{{ 'searchByNameOrEmail' | translate }}</mat-label>
      <mat-icon matPrefix class="search-icon">search</mat-icon>
      <input
        matInput
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        placeholder="{{ 'typeToSearch' | translate }}"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onSelect($event.option.value)"
      >
        <mat-option *ngFor="let user of users" [value]="user">
          <div class="user-option">
            <div class="avatar">{{ getInitials(user) }}</div>
            <div class="user-info">
              <span class="user-name">{{ user.name || user.username || '—' }}</span>
              <span class="user-email">{{ user.primaryEmail || '' }}</span>
            </div>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <app-invite-link></app-invite-link>

    <div class="selected-user-card" *ngIf="selectedUser">
      <div class="avatar avatar--large">{{ getInitials(selectedUser) }}</div>
      <div class="selected-user-info">
        <span class="selected-name">{{ selectedUser.name || selectedUser.username }}</span>
        <span class="selected-email">{{ selectedUser.primaryEmail }}</span>
      </div>
      <button
        mat-raised-button
        color="primary"
        class="add-btn"
        (click)="addAdmin()"
        [disabled]="saving"
      >
        <mat-icon>add</mat-icon>
        {{ 'addAsAdmin' | translate }}
      </button>
    </div>

    <div class="admins-section">
      <h3 class="section-title">{{ 'currentAdmins' | translate }}</h3>

      <div class="loading-row" *ngIf="loading">
        <mat-spinner diameter="28"></mat-spinner>
      </div>

      <ng-container *ngIf="!loading">
        <div class="admin-list" *ngIf="admins.length; else noAdmins">
          <div class="admin-row" *ngFor="let row of admins">
            <div class="avatar">{{ getInitials(row.user) }}</div>
            <div class="user-info">
              <span class="user-name">
                {{ row.user?.name || row.user?.username || row.assignment.logtoUserId }}
              </span>
              <span class="user-email">
                {{ row.user?.primaryEmail || ('userNotFoundInLogto' | translate) }}
              </span>
            </div>
            <button mat-icon-button color="warn" (click)="removeAdmin(row)" title="{{ 'removeAdmin' | translate }}">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>

        <ng-template #noAdmins>
          <div class="empty-state">
            <mat-icon class="empty-icon">group_off</mat-icon>
            <p>{{ 'noAdminsAssigned' | translate }}</p>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </mat-dialog-content>
</div>
